import { Link } from "react-router-dom";
import { useAppContext } from "../contexts/AppProvider";
import { FaCode, FaHouse, FaPenFancy, FaLayerGroup, FaCube, FaCat, FaDog} from "react-icons/fa6";
import { GiClubs, GiSpades, GiDiamonds } from "react-icons/gi";
import { toast } from "react-hot-toast";
import { useEffect, useState, useRef } from "react";

const Navbar = () => {
    const { authToken, logout } = useAppContext();
    const [isAboutOpen, setIsAboutOpen] = useState(false);
    const aboutRef = useRef<HTMLLIElement | null>(null);
    const [isMobileAboutOpen, setIsMobileAboutOpen] = useState(false);
    const mobileAboutRef = useRef<HTMLLIElement | null>(null);

    const handleUnderConstruction = () => {
        toast.custom(
            (t) => (
                <div
                    className={`${
                        t.visible ? "animate-enter" : "animate-leave"
                    } bg-[#0a1628]/95 backdrop-blur-xl border-2 border-purple-500 shadow-[0_0_20px_rgba(168,85,247,0.4)] 
                    rounded-2xl px-6 py-4 flex items-center gap-4 min-w-[340px] overflow-hidden relative group`}
                >
                    <div className="relative shrink-0">
                        <div className="w-12 h-12 bg-purple-500/20 rounded-xl flex items-center justify-center border border-purple-500/50 overflow-hidden">
                            <span className="text-2xl group-hover:scale-125 transition-transform duration-300">🐱</span>
                        </div>
                        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-400/30 to-transparent h-1/2 w-full animate-scan"></div>
                    </div>
    
                    <div className="flex-1">
                        <div className="flex items-center gap-2">
                            <h5 className="text-purple-400 text-[11px] font-black uppercase tracking-[0.2em]">
                                NEURAL_LINK_ERROR
                            </h5>
                            <span className="flex h-2 w-2">
                                <span className="animate-ping absolute inline-flex h-2 w-2 rounded-full bg-purple-400 opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-2 w-2 bg-purple-500"></span>
                            </span>
                        </div>
                        <p className="text-slate-200 text-[10px] font-mono leading-tight mt-1 uppercase">
                            Sequence_Mismatch: <span className="text-cyan-400">"CAT_FEATURE_LOCKED"</span>
                            <br/>
                            <span className="text-slate-500 text-[8px]">Status: INSUFFICIENT_PERMISSIONS</span>
                        </p>
                    </div>
    
                    <button 
                        onClick={() => toast.dismiss(t.id)} 
                        className="text-slate-600 hover:text-purple-400 transition-colors self-start"
                    >
                        <FaCode size={14} />
                    </button>
    
                    <div className="absolute bottom-0 left-0 w-full h-[2px] bg-slate-800">
                        <div 
                            className="h-full bg-gradient-to-r from-purple-600 via-cyan-400 to-purple-600"
                            style={{ 
                                animation: t.visible ? 'toastProgress 2s linear forwards' : 'none' 
                            }}
                        ></div>
                    </div>
                </div>
            ),
            { duration: 2000 }
        );
    };

    const closeAllMenus = () => {
        setIsAboutOpen(false);
        setIsMobileAboutOpen(false);
    };

    useEffect(() => {
        const handleResize = () => {
        const isMobile = window.innerWidth < 768;
        document.body.style.paddingBottom = isMobile ? "50px" : "0px";
        document.body.style.paddingTop = !isMobile ? "50px" : "0px";
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {

            if (aboutRef.current && !aboutRef.current.contains(event.target as Node)) {
                setIsAboutOpen(false);
            }

            if (mobileAboutRef.current && !mobileAboutRef.current.contains(event.target as Node)) {
                setIsMobileAboutOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const mobileItems = [
        { to: "/", icon: <FaHouse />, label: "Home" },
        { to: "/klog", icon: <FaPenFancy />, label: "BLOG" },
    ];

    const aboutMenus = [
        { label: "HOME", to: "/", icon: <FaHouse /> },
        { label: "KAIPEDIA", to: "/kaipedia", icon: <FaPenFancy /> },
        { label: "SHOWCASE", to: "/showcase", icon: <FaCube /> },
        { label: "CATCASE", to: "/catcase", icon: <FaCat /> },
        { label: "DOGCASE", to: "/dogcase", icon: <FaDog /> },
    ];

    const aboutMenusDestkop = [
        { label: "SHOWCASE", to: "/showcase", icon: <FaCube /> },
        { label: "CATCASE", to: "/catcase", icon: <FaCat /> },
        { label: "DOGCASE", to: "/dogcase", icon: <FaDog /> }
    ];

    return (
        <>
            <nav className="hidden md:flex fixed top-0 left-0 w-full z-50 bg-black/80 backdrop-blur-xl border-b border-blue-500/20 text-blue-400 py-3 px-10 justify-between items-center shadow-[0_4px_20px_rgba(30,144,255,0.2)]">
                <div className="flex items-center space-x-2">
                    <FaCode className="text-2xl text-blue-500" />
                    <Link
                        to="/"
                        className="text-xl font-bold bg-gradient-to-r from-blue-500 to-blue-600 bg-clip-text text-transparent hover:from-blue-400 hover:to-blue-500 transition-all"
                    >
                        K
                    </Link>
                </div>

                <ul className="flex space-x-8 text-lg font-semibold">
                    {!authToken ? (
                        <>
                            <li>
                                <Link
                                to="/"
                                className="bg-gradient-to-r from-blue-400 to-blue-500 bg-clip-text text-transparent hover:from-blue-300 hover:to-blue-400 transition-all"
                                >
                                    HOME
                                </Link>
                            </li>
                            <li>
                                <Link
                                to="/kaipedia"
                                className="bg-gradient-to-r from-blue-400 to-blue-500 bg-clip-text text-transparent hover:from-blue-300 hover:to-blue-400 transition-all"
                                >
                                    KAIPEDIA
                                </Link>
                            </li>
                            <li ref={aboutRef} className="relative">
                                <button
                                    onClick={() => setIsAboutOpen((prev) => !prev)}
                                    className="bg-gradient-to-r from-blue-400 to-blue-500 bg-clip-text text-transparent hover:from-blue-300 hover:to-blue-400 transition-all"
                                >
                                    ABOUT
                                </button>

                                {isAboutOpen && (
                                    <ul className="absolute top-full mt-3 w-48 rounded-xl bg-black/90 backdrop-blur-xl border border-blue-500/20 shadow-lg overflow-hidden">
                                        {aboutMenusDestkop.map((menu, i) => (
                                        <li key={i}>
                                            <Link
                                                to={menu.to}
                                                onClick={() => setIsAboutOpen(false)}
                                                className="block px-4 py-3 text-sm hover:bg-blue-500/20 transition"
                                            >
                                                {menu.label}
                                            </Link>
                                        </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        </>
                    ) : (
                        <>
                            <li>
                                <Link to="/skill" className="hover:text-white transition">
                                    Skill
                                </Link>
                            </li>
                            <li>
                                <Link to="/articles" className="hover:text-white transition">
                                    Articles
                                </Link>
                            </li>
                            <li>
                                <Link to="/project" className="hover:text-white transition">
                                    Project
                                </Link>
                            </li>
                            <li>
                                <Link
                                to="/dashboard"
                                className="hover:text-white transition"
                                >
                                    Dashboard
                                </Link>
                            </li>
                            <li>
                                <button
                                onClick={logout}
                                className="px-4 py-2 rounded-md bg-gradient-to-r from-red-500 to-pink-500 text-white font-medium hover:from-red-600 hover:to-pink-600 transition-all duration-300 shadow-[0_0_15px_rgba(239,68,68,0.5)]"
                                >
                                    Logout
                                </button>
                            </li>
                        </>
                    )}
                </ul>

                {!authToken && (
                    <div className="flex space-x-4 text-xl text-gray-300">
                        <button
                            onClick={handleUnderConstruction}
                            className="hover:text-white transition"
                        >
                            <GiClubs />
                        </button>
                        <button
                            onClick={handleUnderConstruction}
                            className="hover:text-white transition"
                        >
                            <GiSpades />
                        </button>
                        <button
                            onClick={handleUnderConstruction}
                            className="hover:text-white transition"
                        >
                            <GiDiamonds />
                        </button>
                    </div>
                )}
            </nav>

            <nav className="md:hidden fixed bottom-0 left-0 w-full z-50 bg-blue/80 backdrop-blur-xl border-t border-blue-500/20 text-blue-400 shadow-[0_-2px_15px_rgba(0,0,0,0.5)]">
                <ul className="flex justify-between items-center h-16 relative px-10"> 

                    <li ref={mobileAboutRef} className="absolute left-1/2 -translate-x-1/2">
                        <button
                            onClick={() => setIsMobileAboutOpen(!isMobileAboutOpen)}
                            className="flex flex-col items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 text-white shadow-lg -mt-10 border-4 border-black transition-transform active:scale-95"
                        >
                            <FaLayerGroup className={`text-xl transition-transform duration-300 ${isMobileAboutOpen ? 'rotate-90' : ''}`} />
                            <span className="text-[9px] font-bold mt-0.5"></span>
                        </button>

                        {isMobileAboutOpen && (
                            <div className="absolute bottom-10 left-1/2 -translate-x-1/2 w-80 h-48 pointer-events-none select-none z-50">
                                <svg className="w-full h-full overflow-visible drop-shadow-[0_0_20px_rgba(59,130,246,0.3)]" viewBox="0 0 200 100">
                                    {aboutMenus.map((menu, i) => {
                                        const n = aboutMenus.length;
                                        const innerRadius = 35;
                                        const outerRadius = 95;
                                        const totalArc = 180; 
                                        const startAngle = 180 + (i * (totalArc / n)) + 2;
                                        const endAngle = 180 + ((i + 1) * (totalArc / n)) - 2;
                                        
                                        const polarToCartesian = (cx: number, cy: number, r: number, angle: number) => {
                                            const rad = (angle * Math.PI) / 180;
                                            return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
                                        };

                                        const p1 = polarToCartesian(100, 100, outerRadius, startAngle);
                                        const p2 = polarToCartesian(100, 100, outerRadius, endAngle);
                                        const p3 = polarToCartesian(100, 100, innerRadius, endAngle);
                                        const p4 = polarToCartesian(100, 100, innerRadius, startAngle);
                                        const d = `M ${p1.x} ${p1.y} A ${outerRadius} ${outerRadius} 0 0 1 ${p2.x} ${p2.y} L ${p3.x} ${p3.y} A ${innerRadius} ${innerRadius} 0 0 0 ${p4.x} ${p4.y} Z`;
                                        const midAngle = startAngle + (endAngle - startAngle) / 2;
                                        const labelPos = polarToCartesian(100, 100, (innerRadius + outerRadius) / 2 + 5, midAngle);

                                        return (
                                            <g key={i} className="group pointer-events-auto cursor-pointer">
                                                <Link to={menu.to} onClick={closeAllMenus}>
                                                    <path d={d} className="fill-black/90 stroke-blue-500/40 stroke-[1] backdrop-blur-md transition-all duration-300 group-hover:fill-blue-600/50 group-hover:stroke-blue-300" />
                                                    <foreignObject x={labelPos.x - 20} y={labelPos.y - 15} width="40" height="30">
                                                        <div className="flex flex-col items-center justify-center h-full text-blue-300 group-hover:text-white transition-all">
                                                            <span className="text-sm">{menu.icon}</span>
                                                        
                                                        </div>
                                                    </foreignObject>
                                                </Link>
                                            </g>
                                        );
                                    })}
                                </svg>
                            </div>
                        )}
                    </li>

                </ul>
            </nav>
        </>
    );
};

export default Navbar;
